module.exports = __webpack_public_path__ + "img/invoice_terbuat.470ed276.png";